/* eslint-disable @typescript-eslint/no-explicit-any */
import { ModuleBase } from './ModuleBase'
import { hall } from '@/hall'
import { base } from '@/base/base'
import { WebDefine } from '@/defines/WebDefine'
import { log } from '@/utils/functions'

export class RolloverModule extends ModuleBase {
  private RETRY_COUNT = 3 //3次重连机会
  public ListNum = 11 //最多一页展示数量
  public typeIndex = 0
  public stateIndex = 0

  public rolloverList: any[] = [] //打码订单列表
  public rolloverMax = 0

  public longADD = 0
  init(): void {}

  onClear(): void {
    this.rolloverList = []
    this.rolloverMax = 0
  }
  onLoad(): void {}
  onDestroy(): void {}

  onPreloadData(): void {
    this.tryGetRolloverInfos_(0)
  }

  inits2c(): void {}

  getRolloverTypeString(index?: number) {
    if (index == null) {
      index = hall.rolloverModule.typeIndex
    }
    let string = ''
    switch (index) {
      case 0:
        string = hall.Language.rolloverAllType
        break
      case 1:
        string = hall.Language.rolloverDeposit
        break
      case 2:
        string = hall.Language.rolloverFreeCash
        break
    }
    return string
  }

  getRolloverStateString(index?: number) {
    if (index == null) {
      index = hall.rolloverModule.stateIndex
    }
    let string = ''
    switch (index) {
      case 0:
        string = hall.Language.RolloverALLSTATUS
        break
      case 1:
        string = hall.Language.RolloverNOTSTARTED // NOT STARTED未开始
        break
      case 2:
        string = hall.Language.RolloverONGOING //ONGOING 进行中
        break
      case 3:
        string = hall.Language.RolloverCOMPLETED //"COMPLETED"完成
        break
      case 4:
        string = hall.Language.RolloverCANCELED //CANCELED已取消
        break
    }
    return string
  }

  tryGetRolloverInfos_(count: number) {
    if (this.longADD > 10) {
      return
    }
    log('tryGetRolloverInfos_ count =', count)
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
      index: this.rolloverList.length,
      size: this.ListNum,
    }
    base.httpUtil
      .postJson(WebDefine.userRolloverList, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          this.longADD += 1
          this.rolloverMax = respJson.data.total
          if (this.rolloverList.length != this.rolloverMax) {
            //判断当前列表数量是不是超了最多显示（先拿部分展示，然后慢慢加载）

            this.mergeTables(respJson.data)

            if (respJson.data.total <= this.rolloverMax) {
              if (this.rolloverList.length >= respJson.data.total) {
                //全部请求完毕了
                hall.eventDispatcher.emit(hall.EventDefine.RolloverListChange)
              } else {
                this.tryGetRolloverInfos_(0)
              }
            } else {
              //数量大于闸值，先拿一部分显示，后面继续请求获取
              if (this.rolloverList.length == this.rolloverMax) {
                hall.eventDispatcher.emit(hall.EventDefine.RolloverListChange)
                if (this.rolloverMax < respJson.data.total) {
                  //继续请求
                  this.tryGetRolloverInfos_(0)
                }
              } else if (this.rolloverList.length == respJson.data.total) {
                //全部请求完毕了
                hall.eventDispatcher.emit(hall.EventDefine.RolloverListChangeMax)
              } else {
                //继续请求
                this.tryGetRolloverInfos_(0)
              }
            }
          }
        }
      })
      .catch(() => {
        log('tryGetRolloverInfos_ failFun')
        count = count + 1
        if (count > this.RETRY_COUNT) {
          //--直接初始化界面不显示了
        } else {
          this.tryGetRolloverInfos_(count)
        }
      })
  }

  cleanRolloverList() {
    this.rolloverList = []
  }

  mergeTables(t2: any) {
    for (let i = 0; i < t2.list.length; i++) {
      this.rolloverList.push(t2.list[i])
    }
  }

  getRolloverListInfo() {
    return this.rolloverList
  }

  getRolloverMax() {
    return this.rolloverMax
  }
}
